import Crew from "../../crew/Crew";
import SkillNode from "../SkillNode";

export default class AddMinerSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} title 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     * @param {Crew} crew
     * @param {string} skillId
     */
    constructor(id, title, description, totals, iconFileName, cost, purchaseListener, crew, skillId) {
        super(id, title, description, totals, iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Crew}
         */
        this.crew = crew;
        /**
         * @constant
         * @type {string}
         */
        this.skillId = skillId;
    }

    /**
     * @override
     * @returns {boolean}
     */
    onPurchase() {
        if (!super.onPurchase()) {
            return false;
        }

        // Add the miner.
        this.crew.addNewMinerNearMain(this.skillId);

        return true;
    }

    // Node: No need to add miner in onPurchaseFromSave() because all miners will be added when the Crew object
    // is loaded
}